<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户续费订单</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="activeName" type="border-card">
      <!-- 续费订单 strat -->
      <el-tab-pane label="订单列表" name="first">
        <!-- 续费订单 start -->
        <el-form :inline="true" :model="keywords">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.applyinvoicestatus" placeholder="请选择" class="select">
              <el-option label="请选择申请状态" value="0"></el-option>
              <el-option label="不申请开票" value="1"></el-option>
              <el-option label="已申请开票" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.makeinvoicestatus" placeholder="请选择" class="select">
              <el-option label="请选择开票状态" value="0"></el-option>
              <el-option label="待开票" value="1"></el-option>
              <el-option label="已开票" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe>
          <el-table-column prop="Orderid" label="订单号" min-width="17%"></el-table-column>
          <el-table-column prop="Types" label="支付方式" min-width="6%"></el-table-column>
          <el-table-column prop="Applyinvoicestatus" label="申请状态" min-width="6%"></el-table-column>
          <el-table-column prop="Makeinvoicestatus" label="开票状态" min-width="6%"></el-table-column>
          <el-table-column prop="Taocanname" label="套餐名称" min-width="6%"></el-table-column>
          <el-table-column prop="Money" label="订单金额" min-width="6%"></el-table-column>
          <el-table-column prop="GlassUserName" label="用户姓名" min-width="6%"></el-table-column>
          <el-table-column prop="BomsnName" label="设备类型" min-width="8%"></el-table-column>
          <el-table-column prop="SaletypeName" label="销售类型" min-width="8%"></el-table-column>
          <el-table-column prop="Jigouname" label="所属门店" min-width="8%"></el-table-column>
          <el-table-column prop="Dailishangname" label="门店所有人" min-width="7%"></el-table-column>
          <el-table-column prop="Applyinvoicename" label="开票姓名" min-width="8%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="8%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Applyinvoicestatusi == 2" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goCustomerRenewal(scope.row)">管理发票</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 续费订单 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 管理员 end -->

      <!-- 年报 start -->
      <el-tab-pane label="年报" v-loading="tongjiloading">
        <!-- start -->
        <el-form :inline="true" :model="tongji">
          <el-form-item label="">
            <el-date-picker v-model="tongji.tongjitime" type="year" value-format="yyyy" placeholder="统计日期" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearchTongji">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- end -->
        <div class="box">
          <ul class="profit">
            <li class="firstLi">年度总收益：</li>
            <li><span>{{Yearmoney}}</span>元</li>
          </ul>
          <ul class="profit">
            <li class="firstLi">年度总收益（扣除分润后剩余）：</li>
            <li><span>{{Yearmoneyjianqufenrun}}</span>元</li>
          </ul>
          <ul class="profit">
            <li class="firstLi">年度实际支出：</li>
            <li><span>{{Yearmoneypay}}</span>元</li>
          </ul>
          <ul class="profit">
            <li>年度预计到期人数: <br><em>(包括睿世力销售机和静视镜)</em></li>
            <li><span>{{Yearnum}}</span>人</li>
          </ul>
          <ul class="profit">
            <li>年度预计年费收益: <br><em>(包括睿世力销售机和静视镜)</em></li>
            <li><span>{{Yearnumv}}</span>元</li>
          </ul>
        </div>

        <el-table v-loading="tongjiloading" :data="YearList" border stripe class="mt15">
          <el-table-column prop="Month" label="月份" min-width="20px"></el-table-column>
          <el-table-column prop="Money600s" label="收益(600元1年)" min-width="40px"></el-table-column>
          <el-table-column prop="Money300s" label="收益(300元1年)" min-width="40px"></el-table-column>
          <el-table-column prop="Moneyqitas" label="收益(其他)" min-width="40px"></el-table-column>
          <el-table-column prop="Moneyzongs" label="收益(总)" min-width="80px"></el-table-column>
          <el-table-column prop="Moneyzongjianqufenruns" label="收益(总,扣除分润后剩余)" min-width="80px"></el-table-column>
          <el-table-column prop="Moneypay" label="该月出纳实际转账金额" min-width="80px"></el-table-column>
          <el-table-column prop="Num" label="预计到期人数(人)" min-width="80px"></el-table-column>
          <el-table-column prop="Numv" label="预计年费收益" min-width="80px"></el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 年报 end -->

      <el-tab-pane label="管理发票" name="second" disabled="disabled">
        <CustomerRenewalOrderFaPiao ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></CustomerRenewalOrderFaPiao>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import CustomerRenewalOrderFaPiao from '@/componentsSubVue/CustomerRenewalOrderFaPiao.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    CustomerRenewalOrderFaPiao
  },
  name: 'MyCustomerRenewalOrder',
  data () {
    return {
      activeName: 'first',
      keywords: {
        orderid: '',
        applyinvoicestatus: '0',
        makeinvoicestatus: '0'
      },
      tongji: {
        tongjitime: ''
      },
      tongjiloading: false,
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      Yearmoney: '0',
      Yearmoneyjianqufenrun: '0',
      Yearmoneypay: '0',
      Yearnum: '0',
      Yearnumv: '0',
      YearList: []
    }
  },
  mounted () {
    this.apiCustomerRenewalOrdernum()
    this.apiCustomerRenewalOrderlist()

    this.tongji.tongjitime = Vue.prototype.FunGetTimeStringY().toString()
    this.apiCustomerRenewalOrderReport()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiCustomerRenewalOrdernum()
      this.apiCustomerRenewalOrderlist()
    },
    clickSearchTongji() {
      this.apiCustomerRenewalOrderReport()
    },
    goCustomerRenewal (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '', params: { id: row.Id, makeinvoiceurl: row.Makeinvoiceurl } })
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiCustomerRenewalOrderlist()
    },
    apiCustomerRenewalOrderlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        applyinvoicestatus: that.keywords.applyinvoicestatus,
        makeinvoicestatus: that.keywords.makeinvoicestatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CustomerRenewalOrderlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiCustomerRenewalOrdernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        applyinvoicestatus: that.keywords.applyinvoicestatus,
        makeinvoicestatus: that.keywords.makeinvoicestatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CustomerRenewalOrdernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiCustomerRenewalOrderReport: function () {
      var that = this
      that.tongjiloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        year: that.tongji.tongjitime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CustomerRenewalOrderReport, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.Yearmoney = response.data.Yearmoney
            that.Yearmoneyjianqufenrun = response.data.Yearmoneyjianqufenrun
            that.Yearmoneypay = response.data.Yearmoneypay
            that.Yearnum = response.data.Yearnum
            that.Yearnumv = response.data.Yearnumv
            that.YearList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.tongjiloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.tongjiloading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.box{
    display: flex;
}
.profit{
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    margin-right: 100px;

    & li:first-child{
        width: 168px;

        & em{
            font-style: normal;
            color: #999;
            font-size: 12px;
        }
    }
    & li:last-child{
        flex: 1;

        & span{
            display: inline-block;
            padding-right: 5px;
            color: #f56c6c;
            font-size: 16px;
        }
    }
    & li.firstLi{
        width: 128px;
    }
}
</style>
